import React, { useState, useCallback } from "react";
import Navbar from "@/components/lumiqo/Navbar";
import Hero from "@/components/lumiqo/Hero";
import Marquee from "@/components/lumiqo/Marquee";
import Services from "@/components/lumiqo/Services";
import HowItWorks from "@/components/lumiqo/HowItWorks";
import Portfolio from "@/components/lumiqo/Portfolio";
import ReelCovers from "@/components/lumiqo/ReelCovers";
import YouTubeThumbnails from "@/components/lumiqo/YouTubeThumbnails";
import Testimonials from "@/components/lumiqo/Testimonials";
import CTA from "@/components/lumiqo/CTA";
import About from "@/components/lumiqo/About";
import ContactDialog from "@/components/lumiqo/ContactDialog";

const Lumiqo = () => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [presetService, setPresetService] = useState("");

  const openContact = useCallback((service = "") => {
    setPresetService(service);
    setDialogOpen(true);
  }, []);

  const scrollToWork = useCallback(() => {
    const el = document.querySelector("#work");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  return (
    <div
      className="relative min-h-screen bg-white text-[#0a1d4d]"
      data-testid="lumiqo-home"
    >
      <Navbar onCTAClick={() => openContact()} />
      <main>
        <Hero onPrimary={scrollToWork} onSecondary={() => openContact()} />
        <Marquee />
        <Services />
        <HowItWorks />
        <Portfolio />
        <ReelCovers />
        <YouTubeThumbnails />
        <Testimonials />
        <CTA onClick={() => openContact()} />
        <About />
      </main>

      <ContactDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        defaultService={presetService}
      />
    </div>
  );
};

export default Lumiqo;
